"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LOGIN_STARTED = exports.LOGIN_STARTED = "@@redux-jwt/LOGIN_STARTED";
var LOGIN_SUCCEED = exports.LOGIN_SUCCEED = "@@redux-jwt/LOGIN_SUCCEED";
var LOGIN_FAILED = exports.LOGIN_FAILED = "@@redux-jwt/LOGIN_FAILED";
var LOGOUT = exports.LOGOUT = "@@redux-jwt/LOGOUT";


// WEBPACK FOOTER //
// ./node_modules/nozzmo-redux-jwt/lib/types.js